
import { SALES_GROWTH_COUNT, SALES_GROWTH_GET } from "../Constants/SalesGrowthConstants";
import { createGetDataReducer } from "./CommonReducer";

const SalesGrowthGetReducer = createGetDataReducer(SALES_GROWTH_GET);
const SalesGrowthCountReducer = createGetDataReducer(SALES_GROWTH_COUNT);




export const SalesGrowthReducers = {
    SalesGrowthGetState: SalesGrowthGetReducer,
    SalesGrowthCountState: SalesGrowthCountReducer,



}